import Dashboard from 'components/Dashboard';
import Reporting from 'components/Reporting';
import ForgotPassword from 'components/auth/ForgotPassword';
import LoginPage from 'components/auth/LoginPage';
import ProtectedRoute from 'components/auth/ProtectedRoute';
import ResetPassword from 'components/auth/ResetPassword';
import SignUp from 'components/auth/SignUp';
import routes from 'config/routes';
import Appointment from 'pages/Appointment';
import Business from 'pages/Business';
import Home from 'pages/Home';
import Payment from 'pages/Payment';
import Pay from 'pages/Payment/Pay';
import { Navigate, Route, Routes } from 'react-router-dom';

import React from 'react';

import './App.css';
import AuthWrapper from 'components/auth/authWrapper';
import TermsAndConditions from 'components/auth/Terms&Conditions';
import HomePage from 'pages/HomePage/HomePage';
import AccessDenied from 'components/auth/AccessDenied'
import PatientAction from 'emails/PatientActionRequired';

const App = () => {
    
    return (
        <Routes>
            {/* Default route for root path */}
            <Route path="/" element={<HomePage/>} />
            
            {/* Public Route */}
            <Route path = {"abc"} element = {<PatientAction/>}/>

            <Route path={routes.auth.login} element={<AuthWrapper><LoginPage /></AuthWrapper>} />
            <Route path={routes.auth.forgotPassword} element={<AuthWrapper> <ForgotPassword /></AuthWrapper>} />
            <Route path={routes.auth.resetPassword} element={<AuthWrapper><ResetPassword /></AuthWrapper>} />
            <Route path={routes.auth.register} element={<AuthWrapper><SignUp /></AuthWrapper>} />
            <Route path={routes.termsAndConditions} element={<AuthWrapper isPopup = {false}><TermsAndConditions /></AuthWrapper>} />
            <Route path={routes.auth.accessDenied} element={<AccessDenied/>} />
            <Route
                path={routes.panel.payment}
                element={
                     <ProtectedRoute>
                        <Payment />
                     </ProtectedRoute>
                }
            />
            <Route
                path={routes.panel.paymentById(':id')}
                element={
                    //  <ProtectedRoute>
                        <Pay />
                    //  </ProtectedRoute>
                }
            />
            <Route
                path={routes.home}
                element={
                     <ProtectedRoute>
                        <Home />
                     </ProtectedRoute>
                }
            />
            <Route
                path={routes.panel.dashboard}
            //     element={
            //         <ProtectedRoute>
            //            <Dashboard />
            //         </ProtectedRoute>
            //    }
                element={<Navigate to={routes.panel.payment} replace />}
            />
            <Route
                path={routes.panel.appointment}
                element={
                     <ProtectedRoute>
                        <Appointment />
                     </ProtectedRoute>
                }
            />
            <Route
                path={routes.panel.reporting}
                element={
                     <ProtectedRoute>
                        <Reporting />
                     </ProtectedRoute>
                }
            />
            <Route
                path={routes.panel.business}
                element={
                     <ProtectedRoute>
                        <Business />
                     </ProtectedRoute>
                }
            />
        </Routes>
    );
};

export default App;
